; (function () {
  let angular = window.angular;

  Controller.$inject = [
    '$element',
    '$state',
    '$uibModal',
    '$translate'
  ];

  angular
    .module('app')
    .component('restrictionYoloClassesTable', {
      template:'<div style="position: relative; min-height: 200px"><div class="panel panel-default"><header class="panel-heading"><h2 class="nowrap"><strong translate>entities.yoloclass.modelNamePl</strong></h2><div class="panel-toolbars pull-right"><div class="panel-toolbar"><button class="btn btn-primary" ng-click="ctrl.showLinkModal()" translate>buttons.add_remove</button></div></div></header><div class="panel-body no-padding"><table id="yolo-class-table" class="table table-hover no-wrap" style="width: 100%"><thead><tr><th></th></tr></thead></table></div></div><spinner show="ctrl.loading" show-logo="true"></spinner></div>',
      controller: Controller,
      controllerAs: 'ctrl',
      bindings: {
        project: '<'
      }
    });

  function Controller($element, $state, $uibModal, $translate) {
    let vm = this;

    vm.$onInit = function onInit() {
      initTable(vm.project.yoloClasses);

      vm.showLinkModal = showLinkModal;
    };

    function initTable(yoloClasses) {
      yoloClasses = yoloClasses || [];
      let dtOptions = {
        dom: '<tr> <\'row\'<\'col-sm-5\'i><\'col-sm-7\'p>>',
        processing: true,
        searching: false,
        info: false,
        data: yoloClasses,
        columns: [{
          data: 'name',
          title: $translate.instant('entities._all.name'),
          render: (value) => $translate.instant('entities.sensor.__classes.' + value)
        }/*, {
          orderable: false,
          data: null,
          defaultContent: '<div class="table-buttons"><button class="btn btn-danger btn-xs"><i class="fas fa-times fa-fw"></i></button></div>'
        }*/]
      };

      const table = $element.find('#yolo-class-table');
      vm.dtInstance = table.DataTable(dtOptions);

    }

    function showLinkModal() {
      $uibModal
        .open({
          animation: true,
          backdrop: 'static',
          bindToController: true,
          component: 'restrictionYoloClassLinkModal',
          resolve: {
            project: () => vm.project
          }
        })
        .result
        .then(function (result) {
          $state.reload();
        })
        .catch(function (err) {
          console.log(err);
        });
    }
  }
})();
